import React, {FC, useState} from "react";
import Button from "./Button";
import {useHistory} from "react-router-dom";
type FooterButtonsProps = {
    previousLocation: string
    saveOnClick: (e: any, link:string) => Promise<void>
    hidePreviousButton?: boolean
    isSubmitting: boolean
}
const FooterButtons = ({previousLocation, saveOnClick, hidePreviousButton, isSubmitting}: FooterButtonsProps )=> {
    const history = useHistory()
    return (
        <>
            {!hidePreviousButton && <button type="button" onClick={(e) =>saveOnClick(e,previousLocation)} disabled={isSubmitting}
                className="fixed bottom-0 left-0 rounded bg-sk-button-unselected uppercase tracking-wider py-2.5 m-2 px-6 border-2
                border-blue-900 text-base font-medium rounded-3xl text-black hover:bg-sk-primary-blue hover:opacity-100 focus:outline- focus:ring-2
                focus:ring-offset-2 transform scale-100 md:scale-75">
                FORRIGE
            </button>}
            <Button type="submit" disabled={isSubmitting} className="fixed bottom-0 right-0 transform scale-100 md:scale-75" style={{backgroundColor: isSubmitting ? 'gray': 'rgba(3, 48, 118, var(--tw-bg-opacity))'}}>
                LAGRE OG<br/>GÅ VIDERE
            </Button>
        </>
    )
}

export default FooterButtons;